import { render, staticRenderFns } from "./localleeds-map.vue?vue&type=template&id=bc9ca632&scoped=true"
import script from "./localleeds-map.vue?vue&type=script&lang=js"
export * from "./localleeds-map.vue?vue&type=script&lang=js"
import style0 from "./localleeds-map.vue?vue&type=style&index=0&id=bc9ca632&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9ca632",
  null
  
)

export default component.exports